function getRoutes() {
  return {
    ROUTE: {
      COLLECTIONS: "collections",
      DETAILS: "details",
    },
  };
}

function getUrl() {
  try {
    let BASE_APPLICATION = "";
    let BASE_URL_IMPORT_EXPORT = "";
    const AUTH0_BASE_URL = process.env.REACT_APP_BASE_APP_URL;
    const NEW_REFACTORING_URL = process.env.REACT_APP_WORKBENCH_URL;
    const NEW_DOCUMENT_PROCESSING_URL = process.env.REACT_APP_DOCUMENTS_URL;

    return {
      URL: {
        COLLECTIONS: {
          GET: NEW_REFACTORING_URL + "/api/workqueues",
          DELETE: BASE_APPLICATION + "/api/collections/$cid",
          KEY: "collections",
        },
        MODEL: {
          GET: NEW_REFACTORING_URL + "/api/models",
          key: "model",
        },
        DOCUMENT: {
          BASE_URL: NEW_REFACTORING_URL + "/api/documents",
          GET_ALL: NEW_REFACTORING_URL + "/api/documents/workqueue/$id",
          GET: BASE_APPLICATION + "/api/collections/$cid/documents/$did",
          POST: BASE_APPLICATION + "/api/collections/$cid/documents",
          DELETE: BASE_APPLICATION + "/api/collections/$cid/documents/$did",
          DOWNLOAD:
            BASE_APPLICATION + "/api/static/collections/$cid/documents/$did",
          KEY: "document",
          SIMILAR_DOCUMENTS:
            NEW_REFACTORING_URL + "/api/documents/similar/$did",
          STRUCTURE:
            BASE_APPLICATION +
            "/api/collections/$cid/documents/$did/structure-text",
          SIMILAR_CLAUSES:
            BASE_APPLICATION +
            "/api/collections/$cid/documents/$did/clauses/$index/similar-clauses",
        },
        DOCUMENT_PROCESSING: {
          KEY: "document_processing",
          CLEAN_FILE: NEW_DOCUMENT_PROCESSING_URL + "/api/cleanfile",
          SPLIT_PDF: NEW_DOCUMENT_PROCESSING_URL + "/api/splitpdf",
          DOWNLOAD_TEMP_PROCESSED_FILE:
            NEW_DOCUMENT_PROCESSING_URL + "/api/download",
          DELETE_FOLDER:
            NEW_DOCUMENT_PROCESSING_URL + "/api/delete/$folderName",
          ROTATE_FILE: NEW_DOCUMENT_PROCESSING_URL + "/api/rotate/image",
        },
        ENTITIES: {
          GET:
            BASE_APPLICATION + "/api/collections/$cid/documents/$did/entities",
          PUT: NEW_REFACTORING_URL + "/api/documents/$did/entities",
          KEY: "entities",
        },
        ENTITIES_TOKEN: {
          GET: BASE_APPLICATION + "/api/collections/$cid/documents/$did/values",
          KEY: "entities_token",
        },
        BOUNDING_BOX: {
          GET: NEW_REFACTORING_URL + "/api/documents/bb/$did",
          KEY: "bounding_box",
        },
        BOUNDING_BOX_CREATE_DATA: {
          GET:
            BASE_APPLICATION +
            "/api/collections/$cid/documents/$did/images/$image/bboxes/text?width=$width&height=$height&x-min=$x1&y-min=$y1&x-max=$x2&y-max=$y2",
          KEY: "bounding_box_create",
        },
        MAPPINGS: {
          GET:
            BASE_APPLICATION + "/api/collections/$cid/documents/$did/mappings",
          POST:
            BASE_APPLICATION + "/api/collections/$cid/documents/$did/mappings",
          KEY: "mappings",
        },
        GROUPS: {
          BASE_URL: NEW_REFACTORING_URL + "/api/groups",
          GET: NEW_REFACTORING_URL + "/api/groups/list/$id",
          KEY: "groups",
        },
        LOGIN: {
          POST: AUTH0_BASE_URL + "/api/user/login",
          KEY: "login",
          CLOUDHUB_LOGIN: AUTH0_BASE_URL + "/api/user/login",
        },
        IMPORTEXPORT: {
          POST: BASE_URL_IMPORT_EXPORT + "/api/connector/export/file",
          KEY: "importexport",
        },
        ORGANISATION: {
          GET: AUTH0_BASE_URL + "/api/customer",
          KEY: "customerOrg",
          CLOUDHUB_ORG: AUTH0_BASE_URL + "/api/customer",
        },
        AUTH0: {
          BASE_URL: AUTH0_BASE_URL,
          key: "auth0",
          CLOUDHUB_AUTH: AUTH0_BASE_URL,
        },
        AZURE_BLOB: {
          BASE_URL: NEW_REFACTORING_URL + "/api/azureblob",
          KEY: "blob-storage",
        },
      },
    };
  } catch (e) {
    console.warn(e);
  }
}

export { getRoutes, getUrl };
